import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-section06',
    templateUrl: './section06.component.html',
    styleUrls: ['./section06.component.scss']
})

export class Section06Component implements OnInit {
    @Input() data;

    constructor() {
    }

    ngOnInit() {
    }
}
